import "../Css/Pagination.css";

const PaginationControls = ({
  totalItems,
  itemsPerPage,
  currentPage,
  onPageChange,
}) => {
  const totalPages = Math.max(1, Math.ceil((totalItems || 0) / itemsPerPage) || 1);
  const safePage = Math.min(Math.max(1, currentPage || 1), totalPages);
  const indexOfFirstItem =
    totalItems === 0 ? 0 : (safePage - 1) * itemsPerPage + 1;
  const indexOfLastItem = Math.min(safePage * itemsPerPage, totalItems || 0);

  if (!totalItems || totalItems <= 0) {
    return null;
  }

  return (
    <div className="pg-bar">
      <p className="pg-meta">
        Showing <strong>{indexOfFirstItem}</strong>–<strong>{indexOfLastItem}</strong> of{" "}
        <strong>{totalItems.toLocaleString()}</strong>
        <span className="pg-meta-pages">
          {" "}
          · Page <strong>{safePage}</strong> of <strong>{totalPages.toLocaleString()}</strong>
        </span>
      </p>

      <div className="pg-controls" role="navigation" aria-label="Pagination">
        <button
          type="button"
          className="pg-btn pg-nav"
          disabled={safePage <= 1}
          onClick={() => onPageChange(safePage - 1)}
          aria-label="Previous page"
        >
          ‹ Previous
        </button>
        <button
          type="button"
          className="pg-btn pg-nav"
          disabled={safePage >= totalPages}
          onClick={() => onPageChange(safePage + 1)}
          aria-label="Next page"
        >
          Next ›
        </button>
      </div>
    </div>
  );
};

export default PaginationControls;
